import React from 'react'
import Proptypes from 'prop-types'

import './style.css'
import NRTCardWithShadow from "../../_common/CardWithShadow"

const defaultImage = require('./default-author.svg')

const Author = (props) => {
    const {mainImageUrl, name, email, description , showAuthorEmail } = props

   return(
        <NRTCardWithShadow className='authors author-container'>
            <div className="author-image">
                <img src={mainImageUrl || defaultImage} alt="Foto instrutor"/>
            </div>
            <div className="author-details">
                <h4>{name}</h4>
                <p className="author-role author-email">{ showAuthorEmail ? email : ''}</p>
                <p className="author-description">{description}</p>
            </div>
        </NRTCardWithShadow>
   )
}

Author.propTypes = {
    mainImageUrl: Proptypes.string,
    name: Proptypes.string.isRequired,
    email: Proptypes.string,
    description: Proptypes.string,
}

export default Author



// WEBPACK FOOTER //
// ./src/components/_courses/Author/index.js